module.exports = __webpack_public_path__ + "static/media/editar.619c30a0.svg";